import React, { useMemo } from 'react';
import Select from 'react-select';
import { CountryCodes } from '../../../data/countryDialCodes';
import { mapCountryDialCodeToCountryObject } from '../../utils/countryService';
import { useIntl } from 'react-intl';
import { useCustomTheme } from '@/app/hooks/useCustomTheme';

const countryList = CountryCodes.map(c => {
  return {
    label: `${c.country} +${c.code}`,
    value: c.code
  };
});
const countryListIso = CountryCodes.map(c => {
  return {
    label: c.iso,
    value: c.code
  };
});

function CountryDialCodePicker({
  countryDialCode,
  setCountryDialCode,
  disabled,
  hideLabel,
  placeholder,
  showIso,
  selectorStyle = {},
  formWrapperStyle = {},
  labelStyle = {},
  labelClass = '',
  applyRegisTheme = false
}) {
  const countryObject = useMemo(() => {
    return mapCountryDialCodeToCountryObject(countryDialCode);
  }, [countryDialCode]);

  const intl = useIntl();
  const theme = useCustomTheme();

  // custom shop branding (theme.regis) is only meant for the registration page,
  // so it should not leak into other places this picker is used
  const placeholderColor = applyRegisTheme ? theme.regis.placeholderColor : undefined;

  return (
    <div style={{ ...formWrapperStyle }}>
      {!hideLabel && (
        <label style={{ fontSize: '1.4rem', marginBottom: '0.6rem', ...labelStyle }} className={labelClass}>
          {intl.formatMessage({ id: 'user.country.placeholder' })}
        </label>
      )}
      <div>
        <Select
          isDisabled={disabled}
          styles={{
            control: styles => ({
              // fontSize: '1.25rem',
              ...styles,
              ...selectorStyle,
              paddingBlock: '0.8rem'
            }),
            placeholder: provided => ({
              ...provided,
              ...(placeholderColor && { color: placeholderColor })
            }),
            singleValue: provided => ({
              ...provided,
              ...(placeholderColor && { color: placeholderColor })
            }),
            option: (provided, state) => ({
              ...provided,
              ...(placeholderColor && { color: placeholderColor })
            })
          }}
          placeholder={placeholder || 'Select country'}
          options={showIso ? countryListIso : countryList}
          value={countryObject}
          onChange={value => {
            setCountryDialCode(value?.value);
          }}
        />
      </div>
    </div>
  );
}

export default CountryDialCodePicker;
